module.exports = __webpack_public_path__ + "img/tu-4.7caf9056.png";